/**
 * Services list previously known as procedures
 * These are services that might be requested by the employer
 * during candidate verification (for now)
 * Some of them are required to obrain employment legalization
 * Some of them are optional but the employer might want to request support with them
 *
 *
 * Only some of them (for now only 1) will result in creation user account -> adding process to the user account
 * For example:
 * Employer requested "Uzyskanie nowego zezwolenia na pobyt" ->
 * -> we will create user account for candidate and we will add new user-process to that acocunt
 *
 *
 * ServiceTypeForEmploymentLegalisation - services required for employment legalization
 * These are the ones that will be specified by the consultant at the stage of providing candidate verification result
 * and will later be displayed to the manager/employer to accept/reject (start/decline procedure).
 */
export enum ServiceTypeForEmploymentLegalisation {
  // Powiadomienie o podjęciu pracy obywatela Ukrainy
  NOTIFICATION_OF_EMPLOYMENT_START_UKR = 'NOTIFICATION_OF_EMPLOYMENT_START_UKR',
  // Notyfikacja do Urzędu Wojewódzkiego
  NOTIFICATION_TO_PROVINCIAL_OFFICE = 'NOTIFICATION_TO_PROVINCIAL_OFFICE',
  // Uzyskanie oświadczenia o powierzeniu wykonywania pracy
  OBTAINING_STATEMENT_ON_ASSIGNMENT_OF_WORK = 'OBTAINING_STATEMENT_ON_ASSIGNMENT_OF_WORK',
  // Uzyskanie zezwolenia na pracę
  OBTAINING_WORK_PERMIT = 'OBTAINING_WORK_PERMIT',
  // Uzyskanie zmiany do posiadanego zezwolenia na pobyt
  OBTAINING_CHANGE_TO_EXISTING_RESIDENCE_PERMIT = 'OBTAINING_CHANGE_TO_EXISTING_RESIDENCE_PERMIT',
  // Uzyskanie nowego zezwolenia na pobyt
  OBTAINING_NEW_RESIDENCE_PERMIT = 'OBTAINING_NEW_RESIDENCE_PERMIT',
  // Rejestracja pobytu obywatela UE
  REGISTRATION_OF_EU_CITIZEN_RESIDENCE = 'REGISTRATION_OF_EU_CITIZEN_RESIDENCE',
  // Wsparcie wizowe
  VISA_SUPPORT = 'VISA_SUPPORT',
}

/**
 * Optional services that might be requested by the employer during candidate verification
 * THese are the services which company can help with and employer might want to request them.
 * These are optional and employer will add them to the candidate verification result if they want to request them
 * but candidate can be employed without them
 */
export enum ServiceTypeOptional {
  // Wsparcie w legalizacji pobytu członków rodziny
  SUPPORT_IN_LEGALIZATION_OF_FAMILY_MEMBERS_RESIDENCE = 'SUPPORT_IN_LEGALIZATION_OF_FAMILY_MEMBERS_RESIDENCE',
  // Wsparcie wizowe dla członków rodziny
  VISA_SUPPORT_FOR_FAMILY_MEMBERS = 'VISA_SUPPORT_FOR_FAMILY_MEMBERS',
  // Koordynacja przeprowadzki do Polski
  RELOCATION_COORDINATION_TO_POLAND = 'RELOCATION_COORDINATION_TO_POLAND',
  // Asysta w poszukiwaniu mieszkania
  ASSISTANCE_IN_FINDING_HOUSING = 'ASSISTANCE_IN_FINDING_HOUSING',
  // Asysta w poszukiwaniu szkoły/przedszkola
  ASSISTANCE_IN_FINDING_SCHOOL_OR_KINDERGARTEN = 'ASSISTANCE_IN_FINDING_SCHOOL_OR_KINDERGARTEN',
  // Asysta w uruchomieniu konta bankowego
  ASSISTANCE_IN_OPENING_BANK_ACCOUNT = 'ASSISTANCE_IN_OPENING_BANK_ACCOUNT',
  // Uzyskanie numeru PESEL (dotyczy osób nowoprzyjezdnych)
  OBTAINING_PESEL_NUMBER = 'OBTAINING_PESEL_NUMBER',
}
